// Full-width strip above the thread header while a past order is open from the
// right rail's Recent feedback tab (look-back). AI-1427.
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { useStyletron } from 'styletron-react'
import { formatNumericDate } from 'utilities/dateFormatters'

const t = buildTranslate('feedback_inbox.lookback')

export interface PastFeedbackIndicatorProps {
  // ISO date of the past order being viewed.
  date: string
}

const PastFeedbackIndicator = ({ date }: PastFeedbackIndicatorProps) => {
  const [css] = useStyletron()

  return (
    <div
      className={css({
        flex: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        backgroundColor: palette.eggYolk10,
        // eggYolk text on eggYolk10 fails AA, so use eggYolk80 (5.3:1).
        color: palette.eggYolk80,
        fontSize: '14px',
        fontWeight: 700,
      })}
    >
      <i className="fa fa-clock-o" aria-hidden="true" />
      <span>{t('heading', { date: formatNumericDate(date) })}</span>
    </div>
  )
}

export default PastFeedbackIndicator
